import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=0598391a&scoped=true"
import script from "./permissions.vue?vue&type=script&lang=js"
export * from "./permissions.vue?vue&type=script&lang=js"
import style0 from "./permissions.vue?vue&type=style&index=0&id=0598391a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0598391a",
  null
  
)

export default component.exports